import { orgDashboardCount, orgTripBookList, orgTripdashFun, orgTripDashStats } from '../../../api/orgTripAPI';
import errorHandle from '../../../utils/errorHandle';

export const getTableData = (selected, setTableData, bookingsOnly, limit, offset, setLoading) => {
    setLoading(true);

    try {
        orgTripdashFun(selected, bookingsOnly, limit, offset).then((item) => {
            const data = item.data.map((item) => {
                return {
                    _id: item._id,
                    name: item?.contentId?.title ?? 'N/A',
                    startDate: item?.startDate?.split('T')[0] ?? 'N/A',
                    days: item?.contentId?.days,
                    nights: item?.contentId?.nights,
                    bookedSlots: item?.bookedSlots ?? 0,
                    totalSlots: item?.totalSlots ?? 0,
                    status: item?.status ?? '',
                    startCities: item?.contentId?.price?.map((city) => {
                        return {
                            city: city?.startCity,
                            price: city?.price
                        };
                    }),
                    difficulty: item?.contentId?.quickView?.difficulty
                };
            });
            setTableData(data);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
    }
};

export const getKpiData = (setKpiData, setLoading, datesType) => {
    setLoading(true);
    try {
        orgTripDashStats(datesType).then((res) => {
            const result = Object.entries(res.data).map(([name, count]) => ({
                name,
                count
            }));
            setKpiData(result);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
    }
};

export const getCustomTableData = (
    limit,
    setTableData,
    setLoading,
    offset,
    selected,
    datesType,
    trip = '',
    selectedDate = ''
) => {
    setLoading(true);
    try {
        orgTripBookList(limit, offset, trip, selectedDate, selected, datesType).then((res) => {
            setTableData(res.data);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const dashboardCount = (selected, setTotalCount, setLoading) => {
    setLoading(true);
    try {
        orgDashboardCount(selected).then((res) => {
            console.log(res.data);
            setTotalCount(res.data.dashCount);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
